

export const questionnaire = {
  "questionnaire_title": "Questionnaires",
  "questionnaire_questionnaire": "questions",
  "questionnaire_minutes": "minutes",
  "questionnaire_continue": "Continuer",
  "questionnaire_start": "Commencer",
  "questionnaire_finish": "Terminer",
  "questionnaire_completed": "Questionnaire terminé, merci !",
  "questionnaire_point": "points",
  "questionnaire_resume": "Reprendre",
  "questionnaire_card_progress": "{{answered}} sur {{total}}",
  "questionnaire_selected_count_one": "{{count}} choisie",
  "questionnaire_selected_count_other": "{{count}} choisies",
  "questionnaire_about": "Questionnaire pour {{name}}",
  "questionnaire_preview_title": "Simulation du questionnaire",
  "questionnaire_preview_banner": "Simulation — vos réponses ne sont pas enregistrées",
  "questionnaire_preview_loading": "Chargement de la simulation…",
  "questionnaire_preview_invalid": "Ce lien de simulation est invalide ou a expiré.",
  "questionnaire_preview_error": "Impossible de charger le questionnaire (la langue sélectionnée n'est peut-être pas configurée pour cette étude).",
  "questionnaire_preview_empty": "Ce questionnaire ne contient pas encore de questions.",
  "questionnaire_preview_done_title": "Fin du questionnaire",
  "questionnaire_preview_done_score": "Score : {{score}}",
  "questionnaire_preview_restart": "Recommencer",
  "questionnaire_preview_lang_default": "Langue de l'étude",
  "questionnaire_preview_lang_fr": "Français",
  "questionnaire_preview_lang_en": "Anglais",
  "questionnaire_preview_lang_es": "Espagnol",
  "questionnaire_preview_lang_ar": "Arabe",
  "content_preview_chrome": "En-tête et barre de navigation",
  "questionnaire_identity_conflict": "Cette valeur est déjà utilisée par un autre participant. Votre réponse n'a pas été enregistrée.",
  "questionnaire_identity_unknown_external_id": "Numéro de dossier non reconnu — vérifiez le numéro remis par l'équipe. Votre réponse n'a pas été enregistrée."
}